import { render, staticRenderFns } from "./QuoteRemarks.vue?vue&type=template&id=20360c94&scoped=true"
import script from "./QuoteRemarks.vue?vue&type=script&lang=js"
export * from "./QuoteRemarks.vue?vue&type=script&lang=js"
import style0 from "./QuoteRemarks.vue?vue&type=style&index=0&id=20360c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20360c94",
  null
  
)

export default component.exports